import { styled } from '@mui/system'

export const TicketInterestCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2),
  height: '100%',
  '& .infoCon': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
  },
}))

export const SpecialEventsCon = styled('div')(({ theme }) => ({
  width: 'auto',
  margin: theme.spacing(6, 2, 2),
}))
